module.exports = __webpack_public_path__ + "img/career_cluster.cc5b509c.png";